import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { AlertErrorDialogComponent } from './alert-error-dialog/alert-error-dialog.component';
import { LoadingComponent } from './loading/loading.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { SoporteComponent } from './soporte/components/soporte.component';
import { AuditoriaComponent } from './auditoria/auditoria.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionPanel, MatExpansionModule } from '@angular/material/expansion';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabLabel } from '@angular/material/tabs';


@NgModule({
  declarations: [
    AlertDialogComponent,
    AlertErrorDialogComponent,
    LoadingComponent,
    ConfirmComponent,
    SoporteComponent,
    AuditoriaComponent
  ],
  entryComponents:[
    AlertDialogComponent,
    AlertErrorDialogComponent,
    LoadingComponent,
    ConfirmComponent,
    SoporteComponent,
    AuditoriaComponent
  ],
  imports: [
    CommonModule,
    FuseSharedModule,   
    MatIconModule,
    MatToolbarModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatFormFieldModule,
    MatButtonToggleModule,
    MatInputModule
  ]
})
export class SharedModule { }
